import { render, staticRenderFns } from "./PageAccessOnboardingAvatar.vue?vue&type=template&id=2c7cd23c&scoped=true&"
import script from "./PageAccessOnboardingAvatar.vue?vue&type=script&lang=js&"
export * from "./PageAccessOnboardingAvatar.vue?vue&type=script&lang=js&"
import style0 from "./PageAccessOnboardingAvatar.vue?vue&type=style&index=0&id=2c7cd23c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c7cd23c",
  null
  
)

export default component.exports